export default __webpack_public_path__ + "images/default-4ed6765a9cc53b6816b7a9efe54e341c.jpg";